/**
 * @file track-engagement.js
 * @description This script tracks clicks on outbound links on the webpage.
 * It sets up event listeners to handle clicks on anchor elements and dispatches a segment event.
 */
(function () {
  // add click listener for all outbound links
  document.addEventListener("click", function (e) {
    // get the a that was clicked
    const tagName = e.target.tagName.toLowerCase();
    const element = tagName === "a" ? e.target : e.target.closest("a");

    // if the element is not an anchor tag, return
    if (!element) {
      return;
    }

    // if the element does not have an href, return
    if (!element.hasAttribute("href")) {
      return;
    }

    // get the text of the element
    let text =
      tagName === "img"
        ? e.target.alt
        : element.hasAttribute("textContent")
          ? element.textContent
          : "No text";

    // PDF filename override
    const pdfFilename = extractPdfFilename(element.href);
    if (pdfFilename) {
      text = pdfFilename;
    }

    // check if the link is an outbound link
    const outboundMatch = !isInternalLink(element.href);

    const enrollMatch = element.href.match( /(member-?\w*)\.chime\.com\/(signup|enroll)/ )

    // check if the links is not a google or apple play store link
    const storeMatch = element.href.match(
      /(play\.google\.com|apps\.apple\.com)/
    );

    if (outboundMatch && !enrollMatch && !storeMatch) {
      const outboundUrl = element.href;
      const location = window.location.href;

      const segmentAttributes = getModuleTrackingAttributes(element);

      const moduleData = extractModuleData(segmentAttributes);

      // check if the link is a social link
      const socialLinksRegex =
        /https?:\/\/(www\.)?(facebook\.com|twitter\.com|x\.com|instagram\.com)/i;
      const socialMatch = element.href.match(socialLinksRegex);

      // check if the link is an affiliate link
      const affiliateLinksRegex =
        /https?:\/\/(www\.)?(\w+\.)?(affiliate|affiliates|ref|partner|track|clickbank|shareasale|cj|rakuten|impactradius|awin|linksynergy)\..+/i;
      const affiliateMatch = element.href.match(affiliateLinksRegex);

      const linkType = socialMatch
        ? "social"
        : affiliateMatch
          ? "affiliate"
          : "outbound";

      const attributes = [
        ...segmentAttributes,
        ...convertObjectToArray({
          destination: outboundUrl,
          label: text,
          link_type: linkType,
          ...getAdditionalTrackingProperties(),
        }),
      ];

      segmentGenericEvent("track", {
        interaction_type: "INTERACTION_TYPE_OUTBOUND_LINK_TAPPED",
        interaction_details: {
          location,
          action_detail: text,
        },
        additional_data: attributes,
      });

      // Analytics SDK firing
      fireAnalyticsEvent(Track.WebItemClicked, {
        unique_id: 'outbound_link_tapped',
        label: text,
        element_type: 'ELEMENT_TYPE_LINK',
        item_value: outboundUrl,
        item_details: {
          "outbound_link_tapped": {
            "module": {
              ...moduleData,
            },
            "link_type": linkType,
          }
        }
      });
    }
  });

  // function extract pdf filename from href
  function extractPdfFilename(href) {
    try {
      const url = new URL(href, window.location.href);
      const pathname = url.pathname;
      const filename = pathname.split("/").pop();
      if (filename && filename.toLowerCase().endsWith(".pdf")) {
        return decodeURIComponent(filename);
      }
    } catch (err) {
      console.warn("Error extracting PDF filename:", err);
    }
    return null;
  }
})();
